import austinPic from "@/public/images/artists/austin.png";
import { Artist } from "@/types/types";

export const austin = {
  id: "1",
  name: "Austin",
  image: austinPic,
  description: `Austin's vocal qualities combine technical prowess, emotional depth, and a distinct pop sensibility. His smooth, clear, and versatile voice enables him to explore a wide array of musical expressions while maintaining a consistent and recognizable vocal identity.`,
  previewUrl:
    "https://public-assets.audimeestorage.com/artistPreviews%2Faustin-preview.mp3",
  meta: {
    free: false,
    new: false,
  },
  filters: {
    gender: "Male",
    tags: {
      primary: ["Pop", "Dance", "Airy"],
      secondary: ["Singer", "Wide Range"],
    },
    pitchRange: {
      categories: {
        low: "Mid",
        high: "Mid",
      },
      specific: {
        low: 54,
        high: 69,
      },
    },
  },
} as const satisfies Artist;
